/*
    Feature Detections
    ------------------
    Provides classes to indicate when features are supported.
*/

// JS
document.documentElement.className = document.documentElement.className.replace('no-js', '')

// Touch
if (!('ontouchstart' in document.documentElement))
    document.documentElement.className += ' no-touch'
else
    document.documentElement.className += ' touch'

